import Button from "../../UI/Button";
import { useDispatch, useSelector } from "react-redux";
import GuitarSetup from "../../CreateScalePage/ChartEditor/GuitarSetup/GuitarSetup";
import FretboardNotesSelect from "./FretboardNotesSelect";
import classes from "./FretboardSetup.module.css";
import { mainActions } from "../../../store";
import FretboardStartTraining from "./FretboardStartTraining";
import FretboardScaleSelect from "./FretboardScaleSelect";
import FretboardSharpsOrFlats from "./FretboardSharpsOrFlats";
import FretboardShowNoteNames from "./FretboardShowNoteNames";

const FretboardSetup = ({ isTraining, onTraining, showNoteNames, onShowNoteNames, audio, onRetry, onResume, playbackNotice, soundEnabled, onSoundChange}) => {
  const fretboardNotesDisplay = useSelector(
    (state) => state.fretboardNotesDisplay
  );
  const dispatch = useDispatch();

  const onUpdateFretboardDisplay = (index, checked) => {
    dispatch(
      mainActions.setFretboardNotesDisplay({ index: index, value: checked })
    );
  };

  return (
    <table className={classes.tableLayout}>
      <tbody data-tour-target="fretboard-notes">
        <GuitarSetup />
        <FretboardScaleSelect />
        <tr>
          <td></td>
          <td>C</td>
          <td></td>
          <td>D</td>
          <td></td>
          <td>E</td>
          <td>F</td>
          <td></td>
          <td>G</td>
          <td></td>
          <td>A</td>
          <td></td>
          <td>B</td>
        </tr>
        <FretboardNotesSelect
          title="Notes"
          values={fretboardNotesDisplay}
          onUpdate={onUpdateFretboardDisplay}
        />
      </tbody>
      <tbody data-tour-target="fretboard-options">
        <FretboardSharpsOrFlats />
        <tr>
          <td><label htmlFor="fretboard-sound">Sound</label></td>
          <td colSpan={12}>
            <select id="fretboard-sound" className={classes.select} value={soundEnabled ? "on" : "off"}
              onChange={event => onSoundChange(event.target.value === "on")}>
              <option value="on">On</option><option value="off">Off</option>
            </select>
          </td>
        </tr>
        <FretboardShowNoteNames state={showNoteNames} onClick={onShowNoteNames} />
      </tbody>
      <tbody>
        {soundEnabled && (audio.status !== "ready" || playbackNotice) && <tr><td colSpan={13}>
          <div role={audio.status === "error" || audio.status === "blocked" || playbackNotice ? "alert" : "status"}
            aria-label="Fretboard Trainer audio">
            {audio.status === "ready" ? playbackNotice : audio.message}
            {audio.status === "error" && <Button onClick={onRetry}>Retry audio</Button>}
            {audio.status === "blocked" && <Button onClick={onResume}>Resume audio</Button>}
          </div>
        </td></tr>}
        <FretboardStartTraining state={isTraining} onClick={onTraining} />
      </tbody>
    </table>
  );
};

export default FretboardSetup;
